import config from "../config";
import selectedEnvironment from "../env";
import dayjs from 'dayjs';
const API_URL = `${config[selectedEnvironment].API_URL}`;

class PartnerService {
    async createPartner(token, partnerData) {
        try {
            const response = await fetch(`${API_URL}/Partners`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(partnerData)
            });
            return response;
        } catch (error) {
            console.error('Error creating partner:', error);
            throw error;
        }
    }

    async bulkCreatePartners(token, partnersData) {
        try {
            const response = await fetch(`${API_URL}/Partners/bulk`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(partnersData)
            });
            return response;
        } catch (error) {
            console.error('Error bulk creating partners:', error);
            throw error;
        }
    }

    async updatePartner(token, partnerData) {
        try {
            const response = await fetch(`${API_URL}/Partners`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(partnerData)
            });
            return response;
        } catch (error) {
            console.error('Error updating partner:', error);
            throw error;
        }
    }

    async deletePartner(token, partnerId, caseId) {
        try {
            const response = await fetch(`${API_URL}/Partners/Delete`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    id: partnerId,
                    caseId: caseId
                })
            });
            return response;
        } catch (error) {
            console.error('Error deleting partner:', error);
            throw error;
        }
    }

    async getPartnerById(token, partnerId, caseId) {
        try {
            const response = await fetch(`${API_URL}/Partners/GetById`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    id: partnerId,
                    caseId: caseId
                })
            });
            return response;
        } catch (error) {
            console.error('Error getting partner by ID:', error);
            throw error;
        }
    }

    async getPartnersByCaseId(caseId, token) {
        try {
            const response = await fetch(`${API_URL}/Partners/GetByCaseId`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    caseId: caseId
                })
            });
            return response;
        } catch (error) {
            console.error('Error getting partners by case ID:', error);
            throw error;
        }
    }
}

export default new PartnerService();
